<template>
  <v-layout
    :class="containerClass"
  >
    <template
      v-if="!hasCoapplicant"
    >
      <v-flex>
        <v-checkbox
          :input-value="accepted"
          @change="checkBox"
          class="shrink"
          hide-details
        />
      </v-flex>
      <v-flex>
        <div
          class="text-xs-left caption"
          v-html="text"
        >
        </div>
        <div class="caption">
          <slot/>
        </div>
      </v-flex>
    </template>
    <template
      v-else
    >
      <v-flex xs12>
        <div
          class="text-xs-left caption px-4 pb-3"
          v-html="text"
        >
        </div>
      </v-flex>
      <v-flex xs12
        class="ml-4"
      >
        <slot/>
      </v-flex>
      <v-flex xs12
        class="wf-flex"
      >
        <v-checkbox
          :input-value="accepted"
          @change="checkBox"
          class="shrink ml-5 my-2"
          :label="'Applicant'"
          hide-details
        />
      </v-flex>
      <v-flex xs12>
        <v-checkbox
          :input-value="coapplicantAccepted"
          @change="checkCoapplicantBox"
          class="shrink ml-5 my-2"
          :label="'Co-Applicant'"
          hide-details
        />
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
  export default {
    name: 'consent-checkbox',
    props: {
      accepted: {
        type: Boolean,
        default: false
      },
      coapplicantAccepted: {
        type: Boolean,
        default: false
      },
      hasCoapplicant: {
        type: Boolean,
        default: false
      },
      text: {
        type: String,
        default: ''
      }
    },
    computed: {
      containerClass () {
        if (this.hasCoapplicant) {
          return {
            'pb-2': true,
            'pr-3': true,
            'wf-flex-columns': true
          }
        } else {
          return {
            'pb-2': true,
            'pr-3': true
          }
        }
      }
    },
    methods: {
      checkBox (x) {
        this.$emit('boxChecked', x)
      },
      checkCoapplicantBox (x) {
        this.$emit('coapplicantChecked', x)
      }
    }
  }
</script>

<style scoped lang="scss">
  // vuetify override
  .input-group__input {
    display: flex;
    justify-content: center;
  }
</style>
